<template>
  <div>
    <edit
      card-header=""
      :disabled="true"
    />
  </div>
</template>
<script>
import edit from '../community-events/edit.vue'

export default {
  name: 'ViewCommunityEvent',
  components: { edit },
}
</script>
<style lang="">

</style>
